import React from "react";
import FormattedDate from "./FormattedDate";
import ReactAnimatedWeather from "react-animated-weather";
import WeatherTemperature from "./WeatherTemperature";
import WeatherIcon from "./WeatherIcon";
import { WiWindy } from 'weather-icons-react';
import { WiHumidity } from 'weather-icons-react';



export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="container">
        <div className="row mb-20 text-center">
          <div className="col-md-6 d-flex text-center flex-column">
              <div className="city">{props.data.city}</div>
              <div className="date"><FormattedDate date={props.data.date} /></div>
              <div className="condition text-capitalize">{props.data.condition}</div>
              <div><WeatherIcon code={props.data.icon} size={62}></WeatherIcon></div>
          </div>
              <div className="temperature-value col-md-6 d-flex flex-column text-center">
              <WeatherTemperature celsius={props.data.temperature.current} />
              </div>
          </div>
          </div>
          <hr />
          <div className="container">
           <div className="row">
             <div className="humidity col-md-6 d-flex flex-column text-center">Humidity<div/>
             <div><br /></div>
            <div className="humidity-svg"><WiHumidity size={90} color='#fff' /></div>  
           </div>
              <div className="humidity-value col-md-6 d-flex flex-column text-center">
                <strong>{props.data.humidity}</strong>
                </div>
            </div>
          </div>
          <hr />
            <div className="container">
              <div className="row">
                <div className="wind col-md-6 d-flex flex-column text-center">
                  Wind - {""}km/h
                <div className="wind-svg"><WiWindy size={90} color='#fff' /></div>
                </div>
                  <div className="wind-speed-value col-md-6 d-flex flex-column text-center">
                    <strong>{props.data.wind}</strong> 
                  </div>
              </div>
            </div>
        </div>       
    );
}


          